module.exports = __webpack_public_path__ + "static/certyfikat_9001_niem-61cd352598c3a079b6aeeede8d270e72.pdf";